import { createFileRoute } from '@tanstack/react-router';
import { AgentDetailRoute } from '@/pages/referrer/agents/detail-route';

/** Deep link al dettaglio di un agente: la lista sta già sotto. */
export const Route = createFileRoute('/referrer/_layout/agents/_layout/$id')({
  component: AgentDetailRouteComponent,
});

function AgentDetailRouteComponent() {
  const { id } = Route.useParams();

  return <AgentDetailRoute id={id} />;
}
